module.exports = __webpack_public_path__ + "static/img/icon-level-05.3514f93b.svg";